import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { checkPrice } from "../../api/masterItems";

const TONE = {
  ok: "bg-emerald-500/10 text-emerald-600",
  warning: "bg-amber-500/10 text-amber-600",
  critical: "bg-rose-500/10 text-rose-600",
};

// الرقابة السعرية اللحظية لبند PO: 🟢 ضمن التسامح · 🟡 سبب إجباري · 🔴 سبب + اعتماد المدير المالي.
export const usePriceCheck = (masterItemId, unitPrice) => {
  const [verdict, setVerdict] = useState(null);
  useEffect(() => {
    const price = Number(unitPrice);
    if (!masterItemId || !(price > 0)) { setVerdict(null); return undefined; }
    const id = setTimeout(() => {
      checkPrice(masterItemId, price).then(setVerdict).catch(() => setVerdict(null));
    }, 350);
    return () => clearTimeout(id);
  }, [masterItemId, unitPrice]);
  return verdict;
};

export const PriceBadge = ({ verdict, testid }) => {
  const { t } = useTranslation();
  if (!verdict || !verdict.reference_price) return null;
  const sign = verdict.variance_percent > 0 ? "+" : "";
  return (
    <span data-testid={testid} data-severity={verdict.severity}
          className={`num inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[10px] font-bold ${TONE[verdict.severity]}`}>
      {t(`purchases.price.${verdict.severity}`)} · {sign}{verdict.variance_percent}%
      <span className="font-normal opacity-70">({t("purchases.price.ref")} {verdict.reference_price} ±{verdict.tolerance_percent}%)</span>
    </span>
  );
};
